import { FieldOption } from '../../../ui/form/Field'

interface FontWeightDefinition {
    value: number
    key: string
    label: string
}

export const fontWeights: FontWeightDefinition[] = [
    { value: 100, key: 'weight_thin', label: 'Thin' },
    { value: 200, key: 'weight_extra_light', label: 'Extra-light' },
    { value: 300, key: 'weight_light', label: 'Light' },
    { value: 400, key: 'weight_regular', label: 'Regular' },
    { value: 500, key: 'weight_medium', label: 'Medium' },
    { value: 600, key: 'weight_semi_bold', label: 'Semi-bold' },
    { value: 700, key: 'weight_bold', label: 'Bold' },
    { value: 800, key: 'weight_extra_bold', label: 'Extra-bold' },
    { value: 900, key: 'weight_black', label: 'Black' },
]

export const fontWeightOptions = (t: (key: string) => string): FieldOption[] =>
    fontWeights.map(({ value, key }) => ({ key: value, label: `${t(key)} (${value})` }))

export const fontWeightMap = (weights?: number[]): Record<number, string> =>
    (weights ?? []).reduce<Record<number, string>>((acc, weight) => {
        const definition = fontWeights.find(({ value }) => value === weight)
        if (definition) acc[weight] = `${definition.label} (${weight})`
        return acc
    }, {})
